<template>
  <div class="CourseEdit">
    <div class="content-header">
      <div class="container">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">Edit Course</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link to="/">Home</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link to="/courses">Courses</router-link>
              </li>
              <li class="breadcrumb-item active">Edit Course</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <section class="content">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="card card-light">
              <div class="card-header">
                <h3 class="card-title">Edit Course Account</h3>
              </div>
              <div class="card-body">
                <form @submit.prevent="handleSubmit">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="name">
                          Name
                          <span class="text-danger">*</span>
                        </label>
                        <input v-model="course.name" type="text" class="form-control" :class="{ 'is-invalid': $v.course.name.$error, 'is-valid': !$v.course.name.$invalid }" />
                        <div class="invalid-feedback">
                          <span v-if="!$v.course.name.required">Name is required.</span>
                          <span v-if="!$v.course.name.minLength">Name must be at least {{ $v.course.name.$params.minLength.min }} letters.</span>
                          <span v-if="!$v.course.name.maxLength">Name must be at most {{ $v.course.name.$params.maxLength.max }} letters.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="introduction">
                          Introduction
                          <span class="text-danger">*</span>
                        </label>
                        <textarea v-model="course.introduction" class="form-control" :class="{ 'is-invalid': $v.course.introduction.$error, 'is-valid': !$v.course.introduction.$invalid }"></textarea>
                        <div class="invalid-feedback">
                          <span v-if="!$v.course.introduction.required">Introduction is required.</span>
                          <span v-if="!$v.course.introduction.minLength">Introduction must be at least {{ $v.course.introduction.$params.minLength.min }} letters.</span>
                          <span v-if="!$v.course.introduction.maxLength">Introduction must be at most {{ $v.course.introduction.$params.maxLength.max }} letters.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="prerequisite">
                          Prerequisite
                          <span class="text-danger">*</span>
                        </label>
                        <vue-editor v-model="course.prerequisite" :editorToolbar="this.$store.state.editorToolbar" :class="{ 'is-invalid': $v.course.prerequisite.$error, 'is-valid': !$v.course.prerequisite.$invalid }"></vue-editor>
                        <input v-model="course.prerequisite" type="hidden" class="form-control" :class="{ 'is-invalid': $v.course.prerequisite.$error, 'is-valid': !$v.course.prerequisite.$invalid }" />
                        <div class="invalid-feedback">
                          <span v-if="!$v.course.prerequisite.required">Prerequisite is required.</span>
                          <span v-if="!$v.course.prerequisite.minLength">Prerequisite must be at least {{ $v.course.prerequisite.$params.minLength.min }} letters.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="description">
                          Description
                          <span class="text-danger">*</span>
                        </label>
                        <vue-editor v-model="course.description" :editorToolbar="this.$store.state.editorToolbar" :class="{ 'is-invalid': $v.course.description.$error, 'is-valid': !$v.course.description.$invalid }"></vue-editor>
                        <input v-model="course.description" type="hidden" class="form-control" placeholder="e.g. Mark" :class="{ 'is-invalid': $v.course.description.$error, 'is-valid': !$v.course.description.$invalid }" />
                        <div class="invalid-feedback">
                          <span v-if="!$v.course.description.required">Description is required.</span>
                          <span v-if="!$v.course.description.minLength">Description must be at least {{ $v.course.description.$params.minLength.min }} letters.</span>
                        </div>
                      </div>
                      <!-- end col-md-12 -->
                    </div>
                  </div>

                  <button :disabled="isDisabled" class="btn btn-danger" type="submit">
                    <i class="far fa-paper-plane"></i>
                    Update
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";
import { VueEditor } from "vue2-editor";

import { required, email, numeric, minLength, maxLength } from "vuelidate/lib/validators";

export default {
  name: "CourseEdit",
  data() {
    return {
      course: {
        name: "",
        introduction: "",
        prerequisite: "",
        description: "",
      },
      submitted: false,
      isDisabled: false,
    };
  },
  validations: {
    course: {
      name: { required, minLength: minLength(5), maxLength: maxLength(150) },
      introduction: { required, minLength: minLength(25), maxLength: maxLength(300) },
      prerequisite: { required, minLength: minLength(25) },
      description: { required, minLength: minLength(25) },
    },
  },
  components: {
    VueEditor,
  },

  beforeMount() {
    axios
      .get("/authoring/courses/" + this.$route.params.uuid)
      .then((res) => {
        this.course.name = res.data.course.name; //this.user.last_name = res.data.Course.name;
        this.course.introduction = res.data.course.introduction;
        this.course.description = res.data.course.description;
        this.course.prerequisite = res.data.course.prerequisite;
      })
      .catch((error) => {
        // handle error
      });
  },
  computed: {
    s3() {
      return this.$store.state.s3;
    },
  },
  methods: {
    handleSubmit(e) {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isDisabled = false;
        return;
      }

      this.submitted = true;
      this.isDisabled = true;

      axios
        .post("/authoring/courses/edit/" + this.$route.params.uuid, this.course)
        .then((res) => {
          this.submitted = false;

          this.isDisabled = false;
          if (res.data.status === "success") {
            this.$v.$reset();
            this.$swal("Done!", res.data.message, "success");
            this.$router.push({ name: "CourseDetails", params: { uuid: this.$route.params.uuid } });
          } else {
            this.$swal("Done!", res.data.message, "error");
          }
        })
        .catch((err) => {});
    },
  },
};
</script>
